import React, { useState } from "react";
import styled from "styled-components";
import { device } from "../../Util/Breakpoints";
import BlockLayout from "./../Layout/BlockLayout";
import SvgLayout from "./../Layout/SvgLayout";
import { createMarkup } from "../../Helpers/CommonHelper";
import {
  HeadingMunicipality,
  FiguresWrapper
} from "../../Util/StyleProps";
import { primaryColor, secondaryColor } from "../../Util/Colors";
import { useInView } from "react-intersection-observer";
import EmptySpace from "../Elements/EmptySpace";
const AnimatedDiv = styled.div`
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #0f0865;
  transform: scale(${props => (props.inView ? 1 : 0.8)});
  transition: transform 2.0s cubic-bezier(0.175, 0.885, 0.275, 1.235);
  border-radius: 1000px;
  padding: 24px 40px;
  text-align: center;
  font-family: 'Inter';
  letter-spacing: -0.6px;
  width: fit-content;
  font-size: 36px;
  font-weight: 700;
  line-height: 42px;
  letter-spacing: -0.6px;
  
  @media${device.tablet} {
    font-size: 48px;
    line-height: 54px;
    letter-spacing: -0.7px;
  }

  @media${device.laptop} {
      font-size: 64px;
      line-height: 70px;
      letter-spacing: -0.9px;
      padding: 32px 48px;
  }
  
  .label{
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: -0.15px;
    white-space: nowrap;
  }
`;
const FigureBoxPopulation = props => {
  const { municipality1, municipality2, year, scroll } = props;
  const [ref, inView, entry] = useInView({
    /* Optional options */
    threshold: 0.5,
    triggerOnce: true
  });

  // Accessibility
  const ariaLabel = (municipality, year) => {
    return municipality
      ? `I slutet av ${year} var befolkningen i ${
          municipality.name
        } kommun ${municipality.values.slice(-1).pop()} personer`
      : "";
  };

  return (
    <React.Fragment>
      <div ref={ref}>
        <FiguresWrapper>
          {municipality1 ? (
            <SvgLayout marginBottom="30px">
              <HeadingMunicipality
                marginBottom="24px"
                aria-label={ariaLabel(municipality1, year)}
              >
                {municipality1.name}
              </HeadingMunicipality>
              <SvgLayout ariaHidden={true}>
                <AnimatedDiv
                  inView={inView}
                >
                  <div>{municipality1 ? Number(municipality1.values.slice(-1).pop()).toLocaleString('sv-SE') : 0}</div>
                  <div className="label">personer</div>
                </AnimatedDiv>
              </SvgLayout>
            </SvgLayout>
          ) : (
            <div></div>
          )}
          {municipality2 ? (
            <SvgLayout paddingBottom="48px">
              <HeadingMunicipality
                marginBottom="24px"
                color={secondaryColor}
                aria-label={ariaLabel(municipality2, year)}
              >
                {municipality2.name}
              </HeadingMunicipality>
              <SvgLayout ariaHidden={true}>
                <AnimatedDiv
                  inView={inView}
                  style={{
                    color: secondaryColor,
                  }}
                >
                  <div>{municipality2 ? Number(municipality2.values.slice(-1).pop()).toLocaleString('sv-SE') : 0}</div>
                  <div className="label">personer</div>
                </AnimatedDiv>
              </SvgLayout>
            </SvgLayout>
          ) : (
            <SvgLayout width="50%">
              <EmptySpace scroll={scroll} />
            </SvgLayout>
          )}
        </FiguresWrapper>
      </div>
    </React.Fragment>
  );
};

export default FigureBoxPopulation;
